import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Command Center CommandBar
 *
 * The hero AI command input with animated gradient border.
 * Shows example prompt with blinking cursor and quick-action chips.
 *
 * Shared component - works in both TekStak (blue) and GAS (orange).
 */
import { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
// =============================================================================
// COMMAND BAR COMPONENT
// =============================================================================
export function CommandBar({ defaultPrompt = 'Scan my 9 CIO accounts, draft outreach, and propose times for the top 3...', chips = [
    'Draft follow-up for Sandra',
    "What's expiring this quarter?",
    'Prep me for the Acme call',
], onRun, onChipClick, }) {
    const [prompt, setPrompt] = useState('');
    const [showCursor, setShowCursor] = useState(true);
    // Typewriter effect for demo prompt
    useEffect(() => {
        if (prompt.length < defaultPrompt.length) {
            const timeout = setTimeout(() => {
                setPrompt(defaultPrompt.slice(0, prompt.length + 1));
            }, 35);
            return () => clearTimeout(timeout);
        }
    }, [prompt, defaultPrompt]);
    // Blinking cursor
    useEffect(() => {
        const interval = setInterval(() => {
            setShowCursor((prev) => !prev);
        }, 530);
        return () => clearInterval(interval);
    }, []);
    return (_jsx("div", { className: "cc-hero-border", style: { marginTop: 18 }, children: _jsxs("div", { style: {
                borderRadius: 15,
                background: 'var(--cc-elevated)',
                padding: '16px 18px',
            }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 11 }, children: [_jsx("span", { style: {
                                width: 30,
                                height: 30,
                                borderRadius: 9,
                                flexShrink: 0,
                                background: 'var(--cc-accent-tint)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }, children: _jsx(Sparkles, { size: 16, style: { color: 'var(--cc-accent)' } }) }), _jsxs("div", { style: {
                                flex: 1,
                                minWidth: 0,
                                fontSize: 14.5,
                                color: 'var(--cc-text)',
                                fontWeight: 600,
                            }, children: [prompt, _jsx("span", { style: {
                                        display: 'inline-block',
                                        width: 2,
                                        height: 16,
                                        background: 'var(--cc-accent)',
                                        marginLeft: 3,
                                        verticalAlign: -3,
                                        opacity: showCursor ? 1 : 0,
                                        transition: 'opacity 0.1s ease',
                                    } })] }), _jsxs("button", { onClick: onRun, style: {
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 7,
                                fontSize: 13,
                                fontWeight: 700,
                                color: 'var(--cc-on-accent)',
                                background: 'var(--cc-accent)',
                                border: 'none',
                                borderRadius: 10,
                                padding: '9px 16px',
                                cursor: 'pointer',
                                transition: 'background 0.14s ease',
                            }, onMouseOver: (e) => {
                                e.currentTarget.style.background = 'var(--cc-accent-strong)';
                            }, onMouseOut: (e) => {
                                e.currentTarget.style.background = 'var(--cc-accent)';
                            }, children: [_jsx(Sparkles, { size: 14 }), "Run"] })] }), _jsx("div", { style: { display: 'flex', gap: 8, marginTop: 13, flexWrap: 'wrap' }, children: chips.map((chip, index) => (_jsx("span", { onClick: () => onChipClick?.(chip), style: {
                            fontSize: 12,
                            fontWeight: 600,
                            color: 'var(--cc-text-2)',
                            background: 'var(--cc-field)',
                            border: '1px solid var(--cc-border)',
                            borderRadius: 8,
                            padding: '6px 11px',
                            cursor: 'pointer',
                            transition: 'border-color 0.14s ease, color 0.14s ease',
                        }, onMouseOver: (e) => {
                            e.currentTarget.style.borderColor = 'var(--cc-accent)';
                            e.currentTarget.style.color = 'var(--cc-text)';
                        }, onMouseOut: (e) => {
                            e.currentTarget.style.borderColor = 'var(--cc-border)';
                            e.currentTarget.style.color = 'var(--cc-text-2)';
                        }, children: chip }, index))) })] }) }));
}
export default CommandBar;
